import { useEffect } from 'react';

import { useAppConfig } from '../context';

export const useLoadAbTastyScript = (scriptUrl: string) => {
  const { abTastyEnabled } = useAppConfig();

  useEffect(() => {
    if (abTastyEnabled) {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;

      document.body.append(script);

      return () => {
        script.remove();
      };
    }

    return () => {};
  }, [abTastyEnabled, scriptUrl]);
};
